import { c as _c } from "react/compiler-runtime";
import {
// deleteLocationAction,
// linkLocation,
// listAvailableLocations,
listAvailableListingsForOrganizationAction, listLocationsForOrganizationAction } from '@/actions/locations';
import { useActiveLocation } from '@/contexts/active-location-context';
import { authClient } from '@/lib/auth-client';
import { useQuery } from '@tanstack/react-query';
import type { Route } from 'next';
import { usePathname, useRouter, useSearchParams } from 'next/navigation';
import { useEffect } from 'react';
type Location = Awaited<ReturnType<typeof listLocationsForOrganizationAction>>[number];
export function useLocations() {
  const $ = _c(32);
  const router = useRouter();
  const pathname = usePathname();
  const searchParams = useSearchParams();
  let t0;
  if ($[0] !== searchParams) {
    t0 = searchParams.get("activeLocationId");
    $[0] = searchParams;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const activeLocationIdParam = t0;
  const {
    activeLocation,
    setActiveLocation
  } = useActiveLocation();
  const {
    data: organizations
  } = authClient.useListOrganizations();
  let t1;
  if ($[2] !== organizations) {
    t1 = organizations?.at(0);
    $[2] = organizations;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const organization = t1;
  const organizationId = organization?.id;
  const organizationIdentifier = `${organization?.slug}-${organization?.id}`;
  let t2;
  if ($[4] !== organizationIdentifier) {
    t2 = ["locations", organizationIdentifier];
    $[4] = organizationIdentifier;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const t3 = !!organizationId;
  let t4;
  if ($[6] !== t2 || $[7] !== t3) {
    t4 = {
      queryKey: t2,
      queryFn: _temp,
      retry: 10,
      retryDelay: _temp2,
      staleTime: 300000,
      refetchOnReconnect: true,
      refetchOnWindowFocus: true,
      refetchOnMount: true,
      refetchInterval: 300000,
      enabled: t3
    };
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const query = useQuery(t4);
  const locations = query.data;
  let t5;
  let t6;
  if ($[9] !== activeLocation || $[10] !== locations || $[11] !== pathname || $[12] !== router || $[13] !== setActiveLocation) {
    t5 = () => {
      if (!activeLocation && locations) {
        if (locations.length > 0) {
          setActiveLocation(locations.at(0) || null);
        } else {
          if (!pathname.startsWith("/app/settings") && !pathname.startsWith("/admin")) {
            router.replace("/app/settings/locations");
          }
        }
      }
    };
    t6 = [locations, activeLocation, setActiveLocation, pathname, router];
    $[9] = activeLocation;
    $[10] = locations;
    $[11] = pathname;
    $[12] = router;
    $[13] = setActiveLocation;
    $[14] = t5;
    $[15] = t6;
  } else {
    t5 = $[14];
    t6 = $[15];
  }
  useEffect(t5, t6);
  let t7;
  let t8;
  if ($[16] !== activeLocation || $[17] !== locations || $[18] !== setActiveLocation) {
    t7 = () => {
      if (!activeLocation?.id || !locations?.length) {
        return;
      }
      const freshActiveLocation = locations.find(location => location.id === activeLocation.id);
      if (!freshActiveLocation) {
        setActiveLocation(locations.at(0) || null);
        return;
      }
      if (JSON.stringify(freshActiveLocation) !== JSON.stringify(activeLocation)) {
        setActiveLocation(freshActiveLocation);
      }
    };
    t8 = [locations, activeLocation, setActiveLocation];
    $[16] = activeLocation;
    $[17] = locations;
    $[18] = setActiveLocation;
    $[19] = t7;
    $[20] = t8;
  } else {
    t7 = $[19];
    t8 = $[20];
  }
  useEffect(t7, t8);
  let t10;
  let t9;
  if ($[21] !== activeLocationIdParam || $[22] !== locations || $[23] !== router || $[24] !== searchParams || $[25] !== setActiveLocation) {
    t9 = () => {
      if (activeLocationIdParam && locations && locations.length > 0) {
        setActiveLocation(locations.find(location_0 => location_0.id === activeLocationIdParam) || null);
        const newSearchParams = new URLSearchParams(searchParams);
        newSearchParams.delete("activeLocationId");
        const nextHref = (newSearchParams.toString() ? `${window.location.pathname}?${newSearchParams.toString()}` : window.location.pathname) as Route;
        router.push(nextHref);
      }
    };
    t10 = [activeLocationIdParam, locations, searchParams, setActiveLocation, router];
    $[21] = activeLocationIdParam;
    $[22] = locations;
    $[23] = router;
    $[24] = searchParams;
    $[25] = setActiveLocation;
    $[26] = t10;
    $[27] = t9;
  } else {
    t10 = $[26];
    t9 = $[27];
  }
  useEffect(t9, t10);
  let t11;
  if ($[28] !== activeLocation || $[29] !== query || $[30] !== setActiveLocation) {
    t11 = {
      ...query,
      activeLocation,
      setActiveLocation
    };
    $[28] = activeLocation;
    $[29] = query;
    $[30] = setActiveLocation;
    $[31] = t11;
  } else {
    t11 = $[31];
  }
  return t11;
}
function _temp2(attemptIndex) {
  return Math.min(1000 * 2 ** attemptIndex, 10000);
}
function _temp() {
  return listLocationsForOrganizationAction();
}
export function useAvailableLocations() {
  const $ = _c(4);
  const {
    data: organizations
  } = authClient.useListOrganizations();
  let t0;
  if ($[0] !== organizations) {
    t0 = organizations?.at(0);
    $[0] = organizations;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const organization = t0;
  const organizationIdentifier = `${organization?.slug}-${organization?.id}`;
  let t1;
  if ($[2] !== organizationIdentifier) {
    t1 = {
      queryKey: ["locations-available", organizationIdentifier],
      queryFn: _temp3,
      retry: 10,
      retryDelay: _temp4,
      staleTime: 300000,
      refetchOnReconnect: true,
      refetchOnWindowFocus: true,
      refetchOnMount: true,
      refetchInterval: 300000
    };
    $[2] = organizationIdentifier;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const query = useQuery(t1);
  return query;
}
function _temp4(attemptIndex) {
  return Math.min(1000 * 2 ** attemptIndex, 10000);
}
function _temp3() {
  return listAvailableListingsForOrganizationAction();
}